export default {
    averageTime: 'เวลาเข้างานเฉลี่ย',
    mon: 'จ.',
    tues: 'อ.',
    wednes: 'พ.',
    thurs: 'พฤ.',
    fri: 'ศ.',
    satur: 'ส.',
    sun: 'อา.'
}
